module.exports = __webpack_public_path__ + "static/reactangular-c91e9a3d03f9f281da4bcafc07b81282.jpg";